import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const WhatsAppButton = () => {
  const { t } = useTranslation();
  return (
    <a
    href="https://wa.me/491791630574"
    target="_blank"
    rel="noopener noreferrer"
      aria-label={t("whatsapp.aria")}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
};

export default WhatsAppButton;